"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("../../../components");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var SessionsCancelContent = function SessionsCancelContent(_ref) {
  var group = _ref.group,
    handlePromptCancel = _ref.handlePromptCancel,
    cancelSession = _ref.cancelSession,
    closeCancelModal = _ref.closeCancelModal;
  var startsAt = (0, _momentTimezone.default)(cancelSession.startAt);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "tw-subtitle-sm-medium text-black px-[20px] pt-[32px] md:pt-[48px] md:px-[0px] md:tw-subtitle-lg-medium"
  }, "Do you want to cancel your registration?"), /*#__PURE__*/_react.default.createElement("div", {
    className: "tw-body-light px-[20px] pt-[20px] pb-[150px] md:px-[0px] md:tw-body-lg-light"
  }, "You will no longer be registered for", ' ', /*#__PURE__*/_react.default.createElement("span", {
    className: "tw-body-medium md:tw-body-lg-medium"
  }, group.name), " on", ' ', startsAt.format('dddd, MMMM D [at] hh:mma, z'), "."), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-row justify-center py-[24px] mx-[-20px] border-0 border-solid border-t border-grey-25 md:pt-[32px] md:pb-[12px]"
  }, /*#__PURE__*/_react.default.createElement(_components.SecondaryButton, {
    className: "w-[145px] h-[46px] mr-[40px] md:mr-[48px] md:w-[196px] label-small-medium",
    onClick: closeCancelModal
  }, "Never mind"), /*#__PURE__*/_react.default.createElement(_components.PrimaryButton, {
    className: "w-[145px] h-[46px] md:w-[196px] label-small-medium",
    onClick: function onClick() {
      return handlePromptCancel(cancelSession);
    }
  }, "Confirm")));
};
var _default = SessionsCancelContent;
exports.default = _default;